"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CloseCircleOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M16,28A12,12,0,1,1,28,16,12,12,0,0,1,16,28m0,2A14,14,0,1,0,2,16,14,14,0,0,0,16,30Z"/><path d="M17.41,16l4.3-4.29a1,1,0,0,0-1.42-1.42L16,14.59l-4.29-4.3a1,1,0,0,0-1.42,1.42L14.59,16l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L16,17.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"/>';
var CloseCircleOutlineSVG = function CloseCircleOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.CloseCircleOutlineSVG = CloseCircleOutlineSVG;
CloseCircleOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CloseCircleOutlineSVG);
exports.default = _default;